NLMK.scrollBlockX = function(){
    const $scrollBlock = $('.js-scroll-block-x');
    const $items = $scrollBlock.find('.filter__item');

    $items.each(function(index){
        $(this).on('click', function(){
            const isActive = $(this).hasClass('active');


            const moveToActive = function(item){
                const $scrollBlockParent = item.closest('.js-scroll-block-x');
                const itemPosition = item.position();
                let itemPositionLeft = itemPosition.left / 2;

                if(index === 1){
                    itemPositionLeft = 1;
                }

                // const scrollLeft = $scrollBlockParent[0].scrollLeft = itemPositionLeft;
                if (innerWidth < 768) {
                    $scrollBlockParent.animate({ scrollLeft: itemPositionLeft}, 300)
                }
            };
            moveToActive($(this));

        });
    });
};

NLMK.scrollBlockX();



// WEBPACK FOOTER //
// ./js/main/module/scroll-block-x.js